import classNames from "classnames";
import {forwardRef, InputHTMLAttributes} from "react";
import {FiAlertCircle} from "react-icons/fi";

import {Icon} from "@/components/icon/Icon.tsx";
import {Input} from "@/components/input/Input.tsx";
import {InputGroup} from "@/components/inputGroup/InputGroup.tsx";

import styles from "./FileInput.module.scss";

interface FileInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "size"> {
  id: string;
  fileName?: string;
  buttonLabel?: string;
}

export const FileInput = forwardRef<HTMLInputElement, FileInputProps>(
  ({id, disabled, accept, fileName, ["aria-invalid"]: ariaInvalid, buttonLabel = "Choose File", ...props}, ref) => {
    return (
      <InputGroup
        disabled={disabled}
        startAddon={
          //This should be <Button as="label" variant="ghost" <...> /> but the styling is wrong in dev due to vite
          // https://github.com/vitejs/vite/issues/3924
          <label className={classNames({disabled: disabled}, "cursor-pointer")} htmlFor={id} aria-disabled={disabled}>
            {buttonLabel}
          </label>
        }
        startAddonProps={{hasHover: true}}
        endElement={ariaInvalid && <Icon icon={FiAlertCircle} className={"text-danger"} />}
      >
        <Input
          as={"label"}
          className={classNames(styles.fileInputFileNameInput, {disabled: disabled})}
          aria-invalid={ariaInvalid}
        >
          <span className={styles.fileInputFileNameText}>{fileName}</span>
          {/*Is not visible so to prevent issues with refs made a regular input.*/}
          <input
            id={id}
            disabled={disabled}
            accept={accept}
            style={{opacity: 0, position: "absolute", width: 0, height: 0}} // display: none does not work as it would prevent using the pseudo class :focus-within
            type="file"
            {...props}
            ref={ref}
          />
        </Input>
      </InputGroup>
    );
  }
);
